module.exports = __webpack_public_path__ + "img/water03.7a050c42.jpg";